(() => {
  if (!customElements.get("un-slider")) {
    class UnSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      init() {
        const slider = this.querySelector(".swiper");
        const pagination = this.querySelector(".swiper-pagination");
        const buttonNext = this.querySelector(".slider-button-next");
        const buttonPrev = this.querySelector(".slider-button-prev");

        const slideAutoPlay = this.getAttribute("data-autoplay");
        const slidesPerView = parseInt(this.getAttribute("data-slide-per-row"));
        const spaceBetweenDes = parseInt(this.getAttribute("data-space-between_des"));
        const spaceBetweenMb = parseInt(this.getAttribute("data-space-between_mb"));
        const showDots = this.getAttribute("data-show-dots");
        const showArrows = this.getAttribute("data-show-arrows");
        const tabletSlidesPerView = parseInt(this.getAttribute("data-tab-slide-per-row"));
        const mobileSlidesPerView = parseInt(this.getAttribute("data-mobile-slide-per-row"));

        const desktopMode = this.getAttribute("data-desktop-slider");
        const mobileAllowSlider = this.getAttribute("data-mobile-slider-allow");

        const swiperOptions = {
          slidesPerView: mobileSlidesPerView,
          spaceBetween: spaceBetweenMb,
          loop: false,
          breakpoints: {
            640: {
              slidesPerView: tabletSlidesPerView,
              spaceBetween: spaceBetweenDes,
            },
            990: {
              slidesPerView: slidesPerView,
              spaceBetween: spaceBetweenDes,
            },
          },
        };

        if (slideAutoPlay === "true") {
          swiperOptions.autoplay = {
            delay: 3000,
            disableOnInteraction: false,
          };
        }

        if (showDots === "true") {
          swiperOptions.pagination = {
            el: pagination,
            clickable: true,
          };
        }

        if (showArrows === "true") {
          swiperOptions.navigation = {
            nextEl: buttonNext,
            prevEl: buttonPrev,
          };
        }

        const handleResponsiveSlider = () => {
          const isMobile = window.innerWidth < 768;
          let enableSlider = false;

          if (desktopMode === "slider") {
            enableSlider = true;
          } else if (desktopMode === "grid") {
            if (isMobile && mobileAllowSlider === "true") {
              enableSlider = true;
            }
          }

          if (enableSlider) {
            if (!this.swiper) {
              this.swiper = new Swiper(slider, swiperOptions);
              this.classList.add("is-slider-active");
              this.classList.remove("is-grid-active");
            }
          } else {
            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }
            this.classList.add("is-grid-active");
            this.classList.remove("is-slider-active");
          }
        };

        handleResponsiveSlider();

        window.addEventListener("resize", () => {
          handleResponsiveSlider();
        });
      }

      connectedCallback() {
        this.init();
      }
    }

    customElements.define("un-slider", UnSlider);
  }
})();